import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconAlignCenter = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="14.8"
    height="11.629"
    viewBox="0 0 14.8 11.629"
    {...props}
  >
    <g transform="translate(0 -54.817)">
      <path
        d="M14.8,64.86v1.057a.536.536,0,0,1-.529.529H.529a.509.509,0,0,1-.372-.157A.509.509,0,0,1,0,65.917V64.86a.508.508,0,0,1,.157-.372.508.508,0,0,1,.372-.157H14.272a.536.536,0,0,1,.529.529ZM3.7,61.16a.536.536,0,0,0-.529.529v1.057a.536.536,0,0,0,.529.529h7.4a.536.536,0,0,0,.529-.529V61.689a.536.536,0,0,0-.529-.529ZM1.586,60.1H13.215a.536.536,0,0,0,.528-.529V58.517a.536.536,0,0,0-.528-.529H1.586a.508.508,0,0,0-.372.157.508.508,0,0,0-.157.372v1.057a.508.508,0,0,0,.157.372A.508.508,0,0,0,1.586,60.1Zm3.172-3.172h5.286a.536.536,0,0,0,.529-.529V55.346a.536.536,0,0,0-.529-.529H4.757a.536.536,0,0,0-.529.529V56.4a.536.536,0,0,0,.529.529Z"
        transform="translate(0 0)"
      />
    </g>
  </SVG>
)

export default withIconStyles(IconAlignCenter)
